







































import Vue from "vue";
import { mapState } from "vuex";
import auth from "@/fire/auth";

export default Vue.extend({
  props: ["drawer"],
  computed: mapState(["user", "currentProject"]),
  methods: {
    signOut() {
      auth.signOut().then(this.onSignOut, this.onSignOutError);
    },
    onSignOut() {
      this.$router.push({ name: "root" });
    },
    onSignOutError() {
      console.log("Sign out error", arguments);
    }
  }
});
